import { convertToRaw } from 'draft-js'

export const selectedApptTypesById = (apptTypeIds, allApptTypesById) =>
  apptTypeIds.reduce(
    (currentTypes, typeId) => ({
      ...currentTypes,
      [typeId]: allApptTypesById[typeId],
    }),
    {},
  )

export const ATReduce = (allTypes, currType) => ({
  ...allTypes,
  [currType.id]: {
    ...currType,
  },
})

const convertMapToObj = mapToConvert =>
  Array.from(mapToConvert).reduce((obj, [key, value]) => (
    Object.assign(obj, { [key]: value })
  ), {})

export const verifyMentionable = (bodyState, mentionable) => {
  const contentState = bodyState.getCurrentContent()
  const entityMap = convertToRaw(contentState).entityMap
  const hasTUTD = Object.keys(entityMap).some((key) => {
    // For some reason, draft-js likes to make some nested objects type ES6 Map
    // instead of a regular Objects. We need to convert these Maps to
    // Objects before accessing the values within.
    const mention = entityMap[key].data.mention
    if (!mention) return false
    const mentionMap = convertMapToObj(mention)
    return mentionMap.name === mentionable || mention.name === mentionable
  })
  return hasTUTD
}

export const verifyThumbsUpThumbsDown = bodyState => (
  verifyMentionable(bodyState, 'thumbs_up_thumbs_down')
)

export const verifyStars = bodyState => (
  verifyMentionable(bodyState, 'stars')
)

export const verifySocialUrl = bodyState => (
  verifyMentionable(bodyState, 'location_facebook_url')
  || verifyMentionable(bodyState, 'location_google_url')
  || verifyMentionable(bodyState, 'location_yelp_url')
)

export const equalArrays = (a, b) => {
  if (a === b) return true
  if (a == null || b == null) return false
  if (a.length !== b.length) return false
  for (let i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false
  }
  return true
}



// WEBPACK FOOTER //
// ./src/components/Settings/utils.js